(function(angular, document) {
    angular.module('wtUi.wtGridTable', ['wtApp.wtCommon', 'wtUi.wtModal', 'ngAnimate'])
        .constant('SCROLLBAR_WIDTH', (function getScrollbarWidth() {
            const outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.width = '100px';
            outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

            document.body.appendChild(outer);

            const widthNoScroll = outer.offsetWidth;
            outer.style.overflow = 'scroll';

            const inner = document.createElement('div');
            inner.style.width = '100%';
            outer.appendChild(inner);

            const widthWithScroll = inner.offsetWidth;

            outer.parentNode.removeChild(outer);

            return widthNoScroll - widthWithScroll;
        })())
        .config(['$translatePartialLoaderProvider', function($translatePartialLoaderProvider) {
            $translatePartialLoaderProvider.addPart('wt-ui/grid-table');
        }]);
})(window.angular, document);
